import { render, staticRenderFns } from "./BrokerFirms.vue?vue&type=template&id=3b0f738d&scoped=true"
import script from "./BrokerFirms.vue?vue&type=script&lang=js"
export * from "./BrokerFirms.vue?vue&type=script&lang=js"
import style0 from "./BrokerFirms.vue?vue&type=style&index=0&id=3b0f738d&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0f738d",
  null
  
)

export default component.exports